import React, { createContext, useContext, useState } from 'react';
import { TEAMS, PLAYERS, TOURNAMENTS, REGISTRATIONS, PAYMENTS, GAMES, MESSAGES, ANNOUNCEMENTS } from '../data/mockData';

const AppContext = createContext(null);

export function AppProvider({ children }) {
  const [teams, setTeams] = useState(TEAMS);
  const [players, setPlayers] = useState(PLAYERS);
  const [tournaments, setTournaments] = useState(TOURNAMENTS);
  const [registrations, setRegistrations] = useState(REGISTRATIONS);
  const [payments, setPayments] = useState(PAYMENTS);
  const [games, setGames] = useState(GAMES);
  const [messages, setMessages] = useState(MESSAGES);
  const [announcements] = useState(ANNOUNCEMENTS);

  const addTeam = (team) => setTeams(p => [...p, { ...team, id: 't' + Date.now() }]);
  const updateTeam = (id, data) => setTeams(p => p.map(t => t.id === id ? { ...t, ...data } : t));

  const addRegistration = (reg) => {
    const id = 'reg' + Date.now();
    setRegistrations(p => [...p, { ...reg, id, createdAt: new Date().toISOString().split('T')[0] }]);
    return id;
  };
  const updateRegistration = (id, data) => setRegistrations(p => p.map(r => r.id === id ? { ...r, ...data } : r));

  const addPayment = (pay) => setPayments(p => [...p, { ...pay, id: 'pay' + Date.now() }]);
  const updatePayment = (id, data) => setPayments(p => p.map(pay => pay.id === id ? { ...pay, ...data } : pay));

  const addGame = (game) => setGames(p => [...p, { ...game, id: 'g' + Date.now() }]);
  const updateGame = (id, data) => setGames(p => p.map(g => g.id === id ? { ...g, ...data } : g));

  const sendMessage = (msg) => setMessages(p => [...p, { ...msg, id: 'm' + Date.now(), createdAt: new Date().toISOString() }]);
  const markRead = (id) => setMessages(p => p.map(m => m.id === id ? { ...m, read: true } : m));

  const unreadCount = messages.filter(m => !m.read).length;

  return (
    <AppContext.Provider value={{
      teams, players, tournaments, registrations, payments, games, messages, announcements,
      addTeam, updateTeam, addRegistration, updateRegistration,
      addPayment, updatePayment, addGame, updateGame,
      sendMessage, markRead, unreadCount,
    }}>
      {children}
    </AppContext.Provider>
  );
}

export const useApp = () => useContext(AppContext);
